<h1 class="page-title">Admin Overview</h1>

<app-card title="Add new Group Admin" [width]="'fit-content'">
  <div [formGroup]="userSearchForm">
    <mat-form-field appearance="outline">
      <mat-label>Search for a user</mat-label>
      <input
        type="text"
        matInput
        formControlName="userSearchCtrl"
        [matAutocomplete]="autoUser"
        />
      <mat-autocomplete #autoUser="matAutocomplete" [displayWith]="displayUser">
        @if (userSuggestions.length > 0) {
          @for (user of userSuggestions; track user) {
            <mat-option [value]="user">
              {{ displayUser(user) }}
            </mat-option>
          }
        } @else {
          <mat-option disabled>
            No users found matching "{{
            userSearchForm.get("userSearchCtrl")?.value
            }}"
          </mat-option>
        }
      </mat-autocomplete>
    </mat-form-field>

    <button
      class="btn"
      [disabled]="!userSearchForm.valid"
      (click)="onAddAdmin()"
      >
      <app-icon name="plus"></app-icon>
      Add group admin
    </button>
  </div>
</app-card>

<app-card title="Admins">
  <div class="table-container">
    <table
      mat-table
      [dataSource]="dataSource"
      multiTemplateDataRows
      class="admin-table"
      >
      <!-- First Name Column -->
      <ng-container matColumnDef="firstName">
        <th mat-header-cell *matHeaderCellDef>First Name</th>
        <td mat-cell *matCellDef="let element">{{ element.firstName }}</td>
      </ng-container>

      <!-- Last Name Column -->
      <ng-container matColumnDef="lastName">
        <th mat-header-cell *matHeaderCellDef>Last Name</th>
        <td mat-cell *matCellDef="let element">{{ element.lastName }}</td>
      </ng-container>

      <!-- Email Column -->
      <ng-container matColumnDef="email">
        <th mat-header-cell *matHeaderCellDef>Email</th>
        <td mat-cell *matCellDef="let element">{{ element.email }}</td>
      </ng-container>

      <!-- Role Column -->
      <ng-container matColumnDef="role">
        <th mat-header-cell *matHeaderCellDef>Role</th>
        <td mat-cell *matCellDef="let element">{{ element.role }}</td>
      </ng-container>

      <!-- Number of Groups Column -->
      <ng-container matColumnDef="numberOfGroups">
        <th mat-header-cell *matHeaderCellDef>Groups</th>
        <td mat-cell *matCellDef="let element">{{ element.numberOfGroups }}</td>
      </ng-container>

      <!-- Expand Column -->
      <ng-container matColumnDef="expand">
        <th mat-header-cell *matHeaderCellDef>&nbsp;</th>
        <td mat-cell *matCellDef="let element">
          <button
            mat-icon-button
            aria-label="expand row"
            (click)="toggle(element); $event.stopPropagation()"
            class="toggle-button"
            [class.expanded]="isExpanded(element)"
            >
            <mat-icon>{{
              isExpanded(element) ? "keyboard_arrow_up" : "keyboard_arrow_down"
            }}</mat-icon>
          </button>
        </td>
      </ng-container>

      <!-- Expanded Content Column -->
      <ng-container matColumnDef="expandedDetail">
        <td
          mat-cell
          *matCellDef="let element"
          [attr.colspan]="columnsToDisplayWithExpand.length"
          >
          <div
            class="element-detail-wrapper"
            [@detailExpand]="isExpanded(element) ? 'expanded' : 'collapsed'"
            >
            @if (isExpanded(element)) {
              <div class="element-detail">
                <div class="admin-actions-detail">
                  @if (element.role !== RolesEnum.superAdmin) {
                    <button
                      class="btn btn-admin"
                  (click)="
                    onAddSuperAdminRights(element); $event.stopPropagation()
                  "
                      >
                      <app-icon name="key"></app-icon>
                      <p>Grant super admin rights</p>
                    </button>
                  }
                  @if (element.role === RolesEnum.groupAdmin) {
                    <button
                      class="btn btn-admin btn-delete"
                  (click)="
                    onRemoveAdminRights(element); $event.stopPropagation()
                  "
                      >
                      <app-icon name="trash"></app-icon>
                      <p>Remove group admin rights</p>
                    </button>
                  }
                </div>
                <div class="groups-list-detail">
                  @if (
                    element.groups && element.groups.length > 0) {
                    <div
                      >
                      @for (group of element.groups; track group) {
                        <div
                          class="group-item-detail"
                          >
                          <div class="group-name-detail">{{ group.groupName }}</div>
                          <div class="group-status-detail">
                            <span
                              class="progress-chip"
                              [ngClass]="groupsService.getGroupTrackingStatus(group)"
                              >
                              {{
                              groupsService.getGroupTrackingStatus(group)
                              | titlecase
                              }}
                            </span>
                          </div>
                        </div>
                      }
                    </div>
                  } @else {
                    <p>{{ element.email }} does not administer any groups.</p>
                  }
                </div>
              </div>
            }
          </div>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="columnsToDisplayWithExpand"></tr>
      <tr
        mat-row
        *matRowDef="let element; columns: columnsToDisplayWithExpand"
        class="element-row"
        [class.expanded-row]="isExpanded(element)"
        (click)="toggle(element)"
      ></tr>
      <tr
        mat-row
        *matRowDef="let row; columns: ['expandedDetail']"
        class="detail-row"
      ></tr>
    </table>
  </div>
</app-card>
